export const SESSION_STORAGE_IS_USER_LOGGED_IN = "SESSION_STORAGE_IS_USER_LOGGED_IN";
export const SESSION_STORAGE_IS_USER_DATA = "SESSION_STORAGE_IS_USER_DATA";

export const SESSION_STORAGE_ACCESS_TOKEN = "SESSION_STORAGE_ACCESS_TOKEN ";
export const SESSION_STORAGE_REFRESH_TOKEN = "SESSION_STORAGE_REFRESH_TOKEN";